import { ReactElement, useMemo, useState, useEffect } from "react";
import { Box } from "@mui/material";

enum Env {
	Test = "TEST",
	Acc = "ACC",
	Prod = "PROD",
	Local = "LOCAL"
}

const ENV_CONFIG = {
	[Env.Test]: { type: Env.Test, check: [ "test.acc.cofanobos.com" ], color: "hsl(115, 80%, 45%)", text: "TEST - " },
	[Env.Acc]: { type: Env.Acc, check: [ ".acc.cofanobos.com" ], color: "hsl(207, 90%, 45%)", text: "ACCEPTANCE - " },
	[Env.Prod]: { type: Env.Prod, check: [ ".cofanobos.com", "cofano.nl" ], color: "#d00", text: "PRODUCTION - " },
	[Env.Local]: { type: Env.Local, check: [ "localhost" ], color: "", text: "" },
};

const LayoutEnvironmentBanner = (): ReactElement | null => {
	const [ isNearBottom, setIsNearBottom ] = useState(false);

	const envData = useMemo(() => {
		const match = Object.values(ENV_CONFIG).find(
			env => env.check.some(domain => window.location.href.includes(domain)),
		);
		return match || ENV_CONFIG[Env.Local];
	}, []);

	useEffect(() => {
		const updateMousePosition = (event: MouseEvent): void => {
			setIsNearBottom(event.clientY > window.innerHeight - 50);
		};
		window.addEventListener("mousemove", updateMousePosition);
		return (): void => {
			window.removeEventListener("mousemove", updateMousePosition);
		};
	}, []);

	if (envData.type == Env.Local) {
		return null;
	}

	return (
		<Box
			component="div"
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				width: "100%",
				height: "24px",
				zIndex: 9,
				whiteSpace: "nowrap",
				textAlign: "center",
				color: "rgba(255, 255, 255, 0.8)",
				lineHeight: "24px",
				fontWeight: "bold",
				wordSpacing: "3px",
				opacity: isNearBottom ? 0 : 0.85,
				backgroundColor: envData.color,
				pointerEvents: "none",
				overflow: "hidden",
				textTransform: "uppercase",
				transition: "all 0.2s ease",
			}}>
			{envData.text.repeat(50)}
		</Box>
	);

};

export default LayoutEnvironmentBanner;
